/**
 * Published prices. Everything that shows a price - the e-invoicing page, its
 * structured data, the homepage band, the Solutions card and the blog banner -
 * reads it from here, so a price change is one edit.
 *
 * validate.js checks the built page against `expectedPrices` in
 * route-config.js; update that list too when a number changes here.
 *
 * Written without a thousands separator ("AED 2499") on purpose - that is the
 * house style for prices.
 */
export const CURRENCY = 'AED';

export const E_INVOICING = {
  assessment: 2499,
  buildFrom: 15000,
};

export const aed = (amount) => `${CURRENCY} ${amount}`;
